import React from 'react';
import { 
  HelpCircle, 
  Target, 
  Users, 
  BarChart2, 
  Zap, 
  Calendar, 
  DollarSign, 
  PieChart
} from 'lucide-react';

/**
 * Компонент боковой панели с советами по рекламным кампаниям
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Target,
      title: 'Цели кампании',
      description: 'Четко определите, что вы хотите достичь: узнаваемость, лиды или продажи.'
    },
    {
      icon: Users,
      title: 'Целевая аудитория',
      description: 'Чем точнее определена аудитория, тем эффективнее расход бюджета.'
    },
    {
      icon: BarChart2,
      title: 'Анализ конкурентов',
      description: 'Изучите, какие каналы и подходы используют ваши конкуренты.'
    },
    {
      icon: Zap,
      title: 'A/B тестирование',
      description: 'Всегда тестируйте несколько версий креативов и посадочных страниц.'
    },
    {
      icon: Calendar,
      title: 'Сезонность',
      description: 'Учитывайте сезонные колебания спроса и корректируйте бюджет.'
    },
    {
      icon: DollarSign,
      title: 'Резервный бюджет',
      description: 'Оставляйте 10-15% бюджета на непредвиденные тесты и возможности.'
    },
    {
      icon: PieChart,
      title: 'Распределение бюджета',
      description: 'Начинайте с наиболее эффективных каналов, постепенно расширяя охват.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по рекламе
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нужна помощь с рекламой?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите профессиональную консультацию по настройке и оптимизации рекламных кампаний.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Связаться с экспертом
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;